import React from 'react'
import Scrollchor from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'So hat Ihre Gemeinde abgestimmt',
    fr: 'Voici ce que votre commune a voté'
  },
  lead: {
    de: (
      <>
        Erfahren Sie, wie man in Ihrer Gemeinde entschieden hat – auf nationaler, kantonaler und kommunaler Ebene. 
        Wie der Service funktioniert,{' '}
        <Scrollchor to='#methodik'>lesen Sie hier</Scrollchor>.
      </>
    ),
    fr: (
      <>
        Découvrez comment votre commune a voté, tant au niveau fédéral, cantonal que communal. 
        Le mode de fonctionnement de ce service est{' '}
        <Scrollchor to='#methodik'>expliqué ici</Scrollchor>.
      </>
    )
  },
  feedback: {
    title: {
      de: 'Wie wars?',
      fr: 'Comment jugez-vous ce contenu?'
    },
    questions: {
      de: [
        'Funktionierte die technische Umsetzung?',
        'Wie beurteilen Sie die Textqualität?',
        'Wie beurteilen Sie den Nutzen dieses Textes?'
      ],
      fr: [
        'La mise en oeuvre technique a-t-elle fonctionné?',
        'Comment évaluez-vous la qualité du texte?',
        'Comment évaluez-vous l’utilité du texte?'
      ]
    }
  },
  methodology: {
    title: {
      de: <>Wie dieser Text geschrieben wurde</>,
      fr: <>Comment ce texte est-il écrit?</>
    },
    text: {
      de: (
        <>
          <p>
          Die Redaktion Tamedia hat einen regelbasierten Algorithmus entworfen, der die rund 4200 deutschen und französischen Abstimmmungstexte für 
          über 2100 Gemeinden automatisch generiert. Die dafür benötigten Daten werden vom <a href='https://opendata.swiss/de/dataset/echtzeitdaten-am-abstimmungstag-zu-eidgenoessischen-abstimmungsvorlagen'>Bundesamt für Statistik</a> bezogen. 
          Die Texte für kommunale Abstimmungen, falls vorhanden, werden von den Redaktionen selbst verfasst. 
          Im Kanton Zürich werden diese Texte automatisch mit Daten des <a href='https://app.statistik.zh.ch/wahlen_abstimmungen/prod/#/Actual'>kantonalen statistischen Amts</a> generiert.
          </p>
          <p>Die Stimmbeteiligung zeigt die <i>durchschnittliche</i> Beteiligung bei den eidgenössischen Vorlagen für die jeweilige Gemeinde, 
          den dazugehörigen Kanton und für die Gesamtschweiz.</p>
        </>
      ),
      fr: (
        <>
          <p>
          La rédaction de Tamedia a développé un algorithme permettant de générer ce texte. Les parties concernant les votes 
          communaux font exception et sont rédigés par la rédaction. Les quelque 4200 textes et tableaux en français 
          et en allemand disponibles ici sont basés sur les résultats des votes des plus de 2100 communes de Suisse. 
          Les données sont fournies par <a href='https://opendata.swiss/fr/dataset/echtzeitdaten-am-abstimmungstag-zu-eidgenoessischen-abstimmungsvorlagen'>l'Office fédéral de la statistique</a>.</p>
          <p>Le taux de participation indique la participation <i>moyenne</i> de la population aux scrutins fédéraux, cantonaux et communaux.</p>
        </>
      )
    }
  },
  credits: {
    de: [
      [
        'Programmierung',
        'Mathieu Rudaz (Frontend) und Timo Grossenbacher (Backend)'
      ],
      [
        'Datenaufbereitung',
        'Mathias Born, basierend auf Daten des Bundesamts für Statistik'
      ],
      [
        'Texte',
        "Timo Grossenbacher, Lucie Monnat (<a href='https://interactif.24heures.ch/2021/atm-vote-2021-09/'>Französisch</a>) und die Tamedia-Redaktionen (kommunale Texte)"
      ],
      ['Bild', 'Viviane Futterknecht'],
      ['Projektleitung', 'Timo Grossenbacher']
    ],
    fr: [
      ['Programmation', 'Mathieu Rudaz (Frontend) et Timo Grossenbacher (Backend)'],
      [
        'Préparation des données',
        'Mathias Born, sur la base des données de l’Office fédéral de la statistique'
      ],
      [
        'Textes',
        "Lucie Monnat (briques de texte en français), Timo Grossenbacher (<a href='https://interaktiv.tagesanzeiger.ch/2021/atm-vote-2021-09/'>allemand</a>) et les rédactions de Tamedia (textes communales)"
      ],
      ['Illustration', 'Viviane Futterknecht'],
      ['Gestion du projet', 'Timo Grossenbacher']
    ]
  }
}

export default LOCALES
